import type { TFunction } from 'i18next'
import type { EntityType } from '@portal/pkg-api/gen/navigator'

/**
 * How a role's Entity Type reads wherever it is shown: its name, marked when the type is
 * disabled, or a placeholder naming the id when the organization no longer has it.
 */
export function entityTypeLabel(
  t: TFunction<'admin-console'>,
  id: number,
  byId: ReadonlyMap<number, EntityType>,
): string {
  const entityType = byId.get(id)
  if (!entityType) return t('roles.entityTypes.unavailable', { id })
  return entityType.enabled
    ? entityType.name
    : t('roles.entityTypes.disabled', { name: entityType.name })
}
